import urls from '../api_urls/media'
import { _post } from '@/axios/request'

export function getCategoryList (params) {
  return _post(urls.getCategoryList, params)
}

export function getCategoryDetail (params) {
  return _post(urls.getCategoryDetail, params)
}

export function getVideoList (params) {
  return _post(urls.getVideoList, params)
}

export function getChannelList (params) {
  return _post(urls.getChannelList, params)
}

export function getVideoDetail (params) {
  return _post(urls.getVideoDetail, params)
}

export function getChannelDetail (params) {
  return _post(urls.getChannelDetail, params)
}

export function getVideoOrder (params) {
  return _post(urls.getVideoOrder, params)
}

export function getChannelOrder (params) {
  return _post(urls.getChannelOrder, params)
}

export function parseUrl (params) {
  return _post(urls.parseUrl, params)
}

export function getKs (params) {
  return _post(urls.getKs, params)
}

export function getMediaFilters (params) {
  return _post(urls.getMediaFilters, params)
}

export function getRelatedWebinar (params) {
  return _post(urls.getRelatedWebinar, params)
}

export function getRelatedEvent (params) {
  return _post(urls.getRelatedEvent, params)
}

export function getRelatedTrend (params) {
  return _post(urls.getRelatedTrend, params)
}

export function getRelatedConcept (params) {
  return _post(urls.getRelatedConcept, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/media.js